<div class="playGolf_landing">
    <!-- box -->
    <div class="box block1 position-relative text-white">
        <img src="/assets/images/playGolfImg1.jpg" alt="Play Golf">
        <div class="d-block">
            <img src="/assets/images/common/play-golf-white.svg" alt="" class="mb-3">
            <h2>{{'FutureOfGolf' | translate}}</h2>
            <!-- appStoreBg -->
            <div class="d-flex appStoreBg mt-4">
                <h6>{{'AICaddieExperience' | translate}}</h6>
                <!-- <a class="d-flex align-items-center text-white appBox">
                    <div class="icon">
                        <img src="/assets/images/common/appStoreIcon.svg" alt="App Store">
                    </div>
                    <div class="d-block">
                        <p>Download on the</p>
                        <h5>App Store</h5>
                    </div>
                </a>
                <a class="d-flex align-items-center text-white appBox">
                    <div class="icon">
                        <img src="/assets/images/common/playStoreIcon.svg" alt="Play Store">
                    </div>
                    <div class="d-block">
                        <p>Get it on</p>
                        <h5>Google Play</h5>
                    </div>
                </a> -->
                @if(!isLoggedIn){
                    <a (click)="openAuthModal('signup')" class="d-flex align-items-center text-white appBox">
                        <div class="d-block ps-0">
                            <p>{{'TryItFree' | translate}}</p>
                            <h5>{{'SignUp' | translate}}</h5>
                        </div>
                    </a>
                }
            </div>
            <!-- appStoreBg -->
             <!-- <p class="sml mt-3">Play Golf and AI Caddie experience are mobile only experiences</p> -->
        </div>
    </div>
    <!-- box -->

    <!-- box -->
    <div class="box block2">
        <div class="row">
            <div class="col-xl-6 pt-5">
                <img src="/assets/images/play-golf-black.svg" alt="" class="mb-3">
                <h2>{{'ThousandsCourses' | translate}}</h2>
                <p class="mt-2">{{'ProLevelInsight' | translate}}</p>
            </div>
            <div class="col-xl-6 mt-3 mtxl-0">
                <img src="/assets/images/phoneFrame1.png" alt="">
            </div>
        </div>
    </div>
    <!-- box -->

    <!-- box -->
    <div class="box block3">
        <div class="row align-items-center">
            <div class="col-xl-6 pt-5 order-xl-2">
                <img src="/assets/images/play-golf-black.svg" alt="" class="mb-3">
                <h2>{{'CaddieKnowsGame' | translate}}</h2>
                <p class="mt-2">{{'NoGuesswork' | translate}}</p>
                <div class="d-flex align-items-center poweredBlock">
                    <img src="/assets/images/ear_buds.svg" alt="">
                    <span class="ps-2">{{'PoweredByVoice' | translate}}</span>
                </div>
            </div>
            <div class="col-xl-6">
                <img src="/assets/images/phoneFrame2.png" alt="">
            </div>
        </div>
    </div>
    <!-- box -->

    <!-- box -->
    <div class="box block4">
        <div class="row">
            <div class="col-xl-6 pb-4 pb-xl-0 align-self-center">
                <img src="/assets/images/bookmarkIcon.svg" alt="" class="mb-3">
                <h2 class="mt-0">{{'AskCaddieRule' | translate}}</h2>
                <h2>{{'TryItFree' | translate}}</h2>
            </div>
            <div class="col-xl-6 rightBox align-self-end d-flex flex-column align-items-start">
                <button class="btn">{{'AskPGAScores' | translate}}</button>
                <button class="btn">{{'AskLIVScores' | translate}}</button>
                <button class="btn">{{'AskGolfRule' | translate}}</button>
                <button class="btn">{{'AskAnyGolfer' | translate}}</button>
                <!-- voice-block -->
                <div class="voice-block bg-white">
                    <input type="text" [placeholder]="'AskAnythingGolf' | translate">
                    <div class="d-inline-flex align-items-center">
                        <button class="btn bg-white p-0 ms-2">
                            <img src="/assets/images/microphone-voice.svg" alt="Microphone">
                        </button>
                        <button class="btn bg-dark p-0 ms-2 border-0">
                            <img src="/assets/images/voiceIcon.svg" alt="Use voice mode">
                        </button>
                    </div>
                </div>
                <!-- voice-block -->
            </div>
        </div>
    </div>
    <!-- box -->

    <!-- box -->
    <div class="box block5 position-relative text-white">
        <img src="/assets/images/playGolfImg2.jpg" alt="Play Golf">
        <div class="d-block">
            <img src="/assets/images/tee-time-icon-white.svg" alt="Tee time" class="mb-3">
            <h2 class="m-0">{{'BookTeeTimeAnywhere' | translate}}</h2>
            <a href="" class="try_it_free">{{'TryItFreeNow' | translate}}</a>
        </div>
    </div>
    <!-- box -->

    <!-- box -->
    <div class="box block6 position-relative text-white">
        <img src="/assets/images/playGolfImg3.jpg" alt="Play Golf">
        <div class="d-flex cont-block">
            <div class="col pb-4 pb-xl-5 pe-0 pe-xl-4">
                <h2>{{'YourEdgeWeapon' | translate}}</h2>
                <p class="mt-4">{{'PersonalCaddie' | translate}}</p>
                <!-- appStoreBg -->
                <div class="d-none d-xl-flex appStoreBg mt-4">
                    <h6>{{'AICaddieExperience' | translate}}</h6>
                    <!-- <a href="" class="d-flex align-items-center text-white appBox">
                        <div class="icon">
                            <img src="/assets/images/common/appStoreIcon.svg" alt="App Store">
                        </div>
                        <div class="d-block">
                            <p>Download on the</p>
                            <h5>App Store</h5>
                        </div>
                    </a>
                    <a href="" class="d-flex align-items-center text-white appBox">
                        <div class="icon">
                            <img src="/assets/images/common/playStoreIcon.svg" alt="Play Store">
                        </div>
                        <div class="d-block">
                            <p>Get it on</p>
                            <h5>Google Play</h5>
                        </div>
                    </a> -->
                    @if(!isLoggedIn){
                    <a (click)="openAuthModal('signup')" class="d-flex align-items-center text-white appBox">
                        <div class="d-block ps-0">
                            <p>{{'TryItFree' | translate}}</p>
                            <h5>{{'SignUp' | translate}}</h5>
                        </div>
                    </a>
                 }
                </div>
                <!-- appStoreBg -->
            </div>
            <div class="frameBg">
                <img src="/assets/images/phoneFrame3.png" alt="">
            </div>
            <!-- appStoreBg -->
            <!-- <div class="d-flex appStoreBg mt-4">
                <a href="" class="d-flex align-items-center text-white appBox">
                    <div class="icon">
                        <img src="/assets/images/common/appStoreIcon.svg" alt="App Store">
                    </div>
                    <div class="d-block">
                        <p>Download on the</p>
                        <h5>App Store</h5>
                    </div>
                </a>
                <a href="" class="d-flex align-items-center text-white appBox">
                    <div class="icon">
                        <img src="/assets/images/common/playStoreIcon.svg" alt="Play Store">
                    </div>
                    <div class="d-block">
                        <p>Get it on</p>
                        <h5>Google Play</h5>
                    </div>
                </a>
                <a href="" class="d-flex align-items-center text-white appBox">
                    <div class="d-block ps-0">
                        <p>{{'TryItFree' | translate}}</p>
                        <h5>{{'SignUp' | translate}}</h5>
                    </div>
                </a>
            </div> -->
            <!-- appStoreBg -->
        </div>
    </div>
    <!-- box -->
</div>